<div i18n class="alert pt-alert-primary" *ngIf="hasVideoScheduledPublication()">
  This video will be published on {{ video.scheduledUpdate.updateAt | date: 'full' }}.
</div>

<div i18n class="alert pt-alert-primary" *ngIf="isWaitingForLive()">
  This live has not started yet.
</div>

<div i18n class="alert pt-alert-primary" *ngIf="isLiveEnded()">
  This live has ended.
</div>

<div class="alert alert-warning" *ngIf="getAlertWarning()">
  {{ getAlertWarning() }}
</div>

<div i18n class="alert alert-warning" *ngIf="noPlaylistVideoFound">
  There are no videos available in this playlist.
</div>

<div class="alert alert-danger" *ngIf="video?.blacklisted">
  <div class="blocked-label" i18n>This video is blocked.</div>
  {{ video.blacklistedReason }}
</div>

<div i18n class="alert alert-warning" *ngIf="video?.canAccessPasswordProtectedVideoWithoutPassword(user)">
  This video is password protected.
</div>
